<dx-popup [title]="'logs.popupTitle' | translate" maxHeight="800" [(visible)]="visible" (onShown)="onShown()" (onHidden)="onHidden()">
    <div *dxTemplate="let data of 'content'">
        <dx-progress-bar width="100%"
                         [height]="15"
                         [value]="false"
                         [visible]="isProgressBarVisible" />
        <dx-scroll-view id="scrollview">
            <div class="form">
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>_commons.information</div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>logs.lblRemotePlatform</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="displayedLog?.remotePlatformName"></dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>logs.lblDate</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="displayLogDate(displayedLog)"></dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>logs.lblType</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="displayLogType(displayedLog)"></dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>logs.lblLocalAgentName</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="displayedLog?.localAgent.name"></dx-text-box>
                        </div>
                    </div>
                </div>
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>_commons.details</div>
                    <div class="dx-field">
                        <dx-text-area class="dx-field-value" [value]="displayedLog?.details" height="250px" width="100%"></dx-text-area>
                    </div>
                </div>
            </div>
        </dx-scroll-view>
        <div class="flex bottom-buttons">
            <dx-button class="close closeButton" [text]="'_commons.close' | translate" (onClick)="this.visible = false"></dx-button>
        </div>
    </div>
</dx-popup>